import { render, staticRenderFns } from "./custom-column2.vue?vue&type=template&id=4bf99a42&scoped=true"
import script from "./custom-column2.vue?vue&type=script&lang=js"
export * from "./custom-column2.vue?vue&type=script&lang=js"
import style0 from "./custom-column2.vue?vue&type=style&index=0&id=4bf99a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf99a42",
  null
  
)

export default component.exports